import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Toaster,toast } from "react-hot-toast";

export default function FarmOverviewUpload() {
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get(
          "https://api.livestockify.com/api/admin/users"
        );
        setUsers(res.data); 
      } catch (err) {
        console.error("Failed to fetch users", err);
      }
    };

    fetchUsers();
  }, []);

  const [formData, setFormData] = useState({
    userId: "",
    overallHealth: "",
    sound: "",
    birdCount: "",
    birdWeight: "",
    abnormality: "",
  });

  const selectedUser = users.find(
    (u) => String(u.id) === String(formData.userId)
  );

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };


const handleSubmit = async () => {
  try {
    if (!selectedUser) {
      toast.error("Please select a user");
      return;
    }

    const payload = {
      userUuid: selectedUser.uuid,
      overallHealth: formData.overallHealth,
      sound: formData.sound,
      approxBirdCount: Number(formData.birdCount),
      approxBirdBodyweightKg: Number(formData.birdWeight),
      physicalAbnormality: formData.abnormality,
    };

    await axios.post(
      "https://api.livestockify.com/api/admin/farm-overview",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Farm Overview updated successfully ✅");

    // optional reset
    setFormData({
      userId: "",
      overallHealth: "",
      sound: "",
      birdCount: "",
      birdWeight: "",
      abnormality: "",
    });
  } catch (err) {
    console.error(err.response?.data || err);
    toast.error("Failed to upload Farm Overview ❌");
  }
};

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />
        <Toaster position="top-right" />

      {/* Main Content */}
      <div className="flex-1 bg-white rounded-l-2xl p-6">
        {/* Header */}
        <h1 className="text-lg font-semibold text-green-700 mb-6">
          Farm Overview Upload
        </h1>

        {/* Form Wrapper */}
        <div className="max-w-3xl mx-auto">
          <div className="space-y-6">
            {/* Select User */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Select User
              </label>
              <div className="col-span-8">
                <select
                  name="userId"
                  value={formData.userId}
                  onChange={handleChange}
                  className="w-full border rounded-md px-4 py-2 text-sm"
                >
                  <option value="">Select User</option>
                  {users.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.name} ({u.email})
                    </option>
                  ))}
                </select>

              

                {selectedUser && (
                  <p className="text-xs text-gray-500 mt-1">
                    userUuid: {selectedUser.uuid}
                  </p>
                )}
              </div>
            </div>

            {/* Overall Health */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Overall Health
              </label>
              <input
                name="overallHealth"
                value={formData.overallHealth}
                onChange={handleChange}
                placeholder="e.g Good"
                className="col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Sound */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Sound
              </label>
              <input
                name="sound"
                value={formData.sound}
                onChange={handleChange}
                placeholder="e.g Normal"
                className="col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Approx Bird Count */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Approx. Bird Count
              </label>
              <input
                name="birdCount"
                value={formData.birdCount}
                onChange={handleChange}
                placeholder="e.g 100"
                className="col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Approx Bird Bodyweight */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Approx. Bird Bodyweight (kg)
              </label>
              <input
                name="birdWeight"
                value={formData.birdWeight}
                onChange={handleChange}
                placeholder="e.g 2.5"
                className="col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Physical Abnormality */}
            <div className="grid grid-cols-1 md:grid-cols-12 items-center gap-2 md:gap-4">
              <label className="md:col-span-4 text-sm font-medium text-gray-700
                     text-center md:text-right">
                Physical Abnormality
              </label>
              <input
                name="abnormality"
                value={formData.abnormality}
                onChange={handleChange}
                placeholder="e.g None"
                className="col-span-8 border rounded-md px-4 py-2 text-sm"
              />
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-center sm:justify-end gap-4 pt-4">
              

              <button
                onClick={() => navigate("/all-users")}
                className="border px-6 py-2 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmit}
                className="px-6 py-2 bg-green-600 text-white rounded-md text-sm"
              >
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
